import React, { useLayoutEffect } from 'react';
import { gsap } from 'gsap';
import { useIsMounted } from '@hooks/useIsMounted';
import { useScrollController } from '@context/ScrollControllerProvider/useScrollController';
import ScrollMagic from 'scrollmagic';
import { Box } from '@components/Box';
import HtmlParser from 'react-html-parser';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';
import { guestListData } from '@data-ts/pages/guest-list';
import { SpacingStack } from '@components/SpacingStack';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { TextBackgroundPhoto } from '@sections/guest-list/TextBackgroundPhoto';
import { StyledTitleText, StyledBodyText } from './EmotionalBreak.styles';

export const EmotionalBreakSection = () => {
  const sectionId = 'Send_and_Track_It_All';
  const scrollController = useScrollController();
  const isMounted = useIsMounted();
  const isMobileDevice = useThemeMediaQuery('below_sm');

  useLayoutEffect(() => {
    let scene: InstanceType<typeof ScrollMagic.Scene> | undefined;
    let emotionalBreakTimeline: ReturnType<typeof gsap.timeline>;

    if (scrollController && isMounted) {
      const initTimeline = () => {
        emotionalBreakTimeline = gsap.timeline({ paused: true });
        emotionalBreakTimeline.to('#EmotionalText', { y: isMobileDevice ? '70%' : '115%' }, 0);
      };
      const initScene = () => {
        scene = new ScrollMagic.Scene({
          triggerElement: `#${sectionId}`,
          triggerHook: 1,
          duration: '100%',
          offset: 400,
        })
          .addTo(scrollController)
          .on('progress', (event: ScrollMagic.SceneProgressEvent) => {
            emotionalBreakTimeline?.progress(event.progress);
          });
      };
      initTimeline();
      initScene();
    }

    const clearScene = () => {
      if (emotionalBreakTimeline) {
        emotionalBreakTimeline.progress(0);
        emotionalBreakTimeline.kill();
      }
      if (scene) {
        scene.destroy(true);
      }
    };
    return clearScene;
  }, [scrollController, isMounted, isMobileDevice]);

  return (
    <Box id={sectionId}>
      <TextBackgroundPhoto
        src={cloudAssetUrl('sitewide/block_emotional-break/messages.jpg')}
        height={'160vh'}
        heightMobile={'70vh'}
        paddingTop={[9, 10, 11]}
        moveText={false}
        backgroundPosition={'bottom'}
      >
        <SpacingStack spacing={7}>
          <Box id="EmotionalText">
            <StyledTitleText color="yellow1" variant="hed96Break" tagName="h2">
              {guestListData.allInvitesText}
            </StyledTitleText>
            <StyledBodyText color="yellow1" variant="dek24" tagName="p">
              {HtmlParser(guestListData.transcendText)}
            </StyledBodyText>
          </Box>
        </SpacingStack>
      </TextBackgroundPhoto>
    </Box>
  );
};
